import EmailIcon from '@mui/icons-material/Email'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    styled,
} from '@mui/material'
import { Stack } from '@mui/system'
import axios from 'axios'
import { useEffect, useRef } from 'react'
import { useAccount } from '../../context/account_context'
import { useBranch } from '../../context/branch_context'
import { useConfigs } from '../../context/configs_context'
import { PreSaleInfo } from '../../context/sale_context'
import { getFileEndpoint } from '../../services/media'
import {
    getDateString,
    maskCurrency,
    numeroPorExtensoEspanhol,
    quandoImagensCarregarem,
} from '../../utils/maks'
import { getBudgetMatrixPrintText } from '../../utils/print'
import { SaleContractNote } from '../SaleContractNoteDialog'

const StyledTableCell = styled(TableCell)(({}) => ({
    color: 'text.primary',
    border: 'none',
    padding: '1px 2px',
    fontSize: '11px',
}))

interface BudgetA4Note {
    budget: PreSaleInfo
}

const ContactIcon: Record<string, JSX.Element> = {
    Facebook: <FacebookIcon />,
    Instagram: <InstagramIcon />,
    Whatsapp: <WhatsAppIcon />,
    Endereço: <LocationOnIcon />,
    Telefone: <LocalPhoneIcon />,
    Email: <EmailIcon />,
}

function BudgeA4tNote({ budget }: BudgetA4Note) {
    const { configs, contactTypes, base64Logo } = useConfigs()
    const { branches } = useBranch()

    const contacts = budget.branch ? budget.branch.contacts : configs.contacts
    const companyName =
        budget.branch && configs.showBranchNameInNote
            ? budget.branch.name
            : configs.companyName
    const companyLogo = budget.branch?.companyLogo
        ? branches.find((b) => b.id === budget.branch?.id)?.companyLogo?.content
        : base64Logo
    const companySlogan = budget.branch?.companySlogan
        ? budget.branch.companySlogan
        : configs.companySlogan

    return (
        <Stack>
            {configs.showContractOnBudget && (
                <SaleContractNote budget={budget} maxHeight />
            )}
            <Stack direction="column" width="100%" px="20px" py="10px" flex={1}>
                <Stack direction={'row'} width={'100%'}>
                    <Stack
                        direction={'column'}
                        border={'1px solid black'}
                        borderRadius={'12px'}
                        width={'100%'}
                    >
                        <Stack direction={'row'} p={'10px'}>
                            <Box
                                component={'img'}
                                src={companyLogo}
                                width={'220px'}
                                height={'110px'}
                                zIndex={'-1'}
                            />
                            <Stack textAlign={'center'} flex={'1'} px={'15px'}>
                                <Typography
                                    fontSize={'14px'}
                                    sx={{ wordBreak: 'break-word' }}
                                >
                                    {companyName}
                                </Typography>
                                <Typography
                                    fontSize={'9px'}
                                    sx={{ wordBreak: 'break-word' }}
                                    fontStyle={'italic'}
                                    whiteSpace={'pre-line'}
                                >
                                    {`${companySlogan}`}
                                </Typography>
                                <Typography
                                    fontSize={'8px'}
                                    sx={{ wordBreak: 'break-word' }}
                                >
                                    {contactTypes
                                        .filter((ct) =>
                                            contacts.find(
                                                (c) =>
                                                    c.contactType.id === ct.id
                                            )
                                        )
                                        .map(
                                            (ct) =>
                                                `${ct.name}: ${contacts
                                                    .filter(
                                                        (c) =>
                                                            c.contactType.id ===
                                                            ct.id
                                                    )
                                                    .map((c) => c.value)
                                                    .join(', ')}`
                                        )
                                        .join('; ')}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>
                    <Stack
                        direction={'column'}
                        border={'1px solid black'}
                        borderRadius={'12px'}
                        width={'30%'}
                    >
                        <Stack direction={'row'} p={'10px'}>
                            <Box flex={'1'}>
                                <Typography fontSize={'11px'} mt={'1px'}>
                                    Fecha:{' '}
                                    {getDateString({
                                        date: budget.date,
                                        hour: budget.hour,
                                        configs: configs,
                                        isSummerTime: !!budget.isSummerTime,
                                    })}
                                </Typography>
                                <Typography fontSize={'11px'} mt={'1px'}>
                                    Vendedor: {budget?.employee?.name}
                                </Typography>
                                {configs.showWeightOnNote && (
                                    <Typography fontSize={'11px'} mt={'1px'}>
                                        Peso total:{' '}
                                        {budget?.products.reduce(
                                            (total, curr) =>
                                                total +
                                                curr.product.realWeight *
                                                    curr.qnt,
                                            0
                                        )}{' '}
                                        kg
                                    </Typography>
                                )}
                                <Typography
                                    fontSize={'13px'}
                                    mt={'5px'}
                                    fontWeight={'bold'}
                                    textAlign={'center'}
                                >
                                    Presupuesto n.º {budget.id}
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    width={'100%'}
                    border={'1px solid black'}
                    borderTop={'0'}
                    borderRadius={'12px'}
                    direction={'column'}
                    padding={'5px'}
                >
                    <Stack direction={'row'} alignItems={'center'}>
                        <Box width={'70%'}>
                            <Typography fontSize={'16px'} fontWeight={'bold'}>
                                Nombre: {budget.client?.name || '---'}
                            </Typography>
                            <Typography fontSize={'16px'} fontWeight={'bold'}>
                                Documento: {budget.client?.document || '---'}
                            </Typography>
                        </Box>
                        <Box>
                            <Box>
                                {/* <Typography fontSize={'11px'}>
                                Fecha:{' '}
                                {getDateString({
                                    date: budget.date,
                                    hour: budget.hour,
                                    configs: configs,
                                    isSummerTime: !!budget.isSummerTime,
                                })}
                            </Typography> */}
                                <Typography fontSize={'11px'}>
                                    Telefonos:{' '}
                                    {budget.client?.phoneNumbers.join(', ') ||
                                        '---'}
                                </Typography>
                                <Typography fontSize={'11px'}>
                                    Dirección: {budget.client?.address || '---'}
                                </Typography>
                            </Box>
                        </Box>
                    </Stack>
                </Stack>
                <Stack
                    width={'100%'}
                    border={'1px solid black'}
                    borderTop={'0'}
                    borderRadius={'12px'}
                    direction={'column'}
                    flex={'1'}
                    justifyContent={'space-between'}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                {configs.showImageOnNote && (
                                    <StyledTableCell
                                        sx={{
                                            borderBottom: '1px solid black',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        IMAGEN
                                    </StyledTableCell>
                                )}
                                {configs.showIdOnNote && (
                                    <StyledTableCell
                                        sx={{
                                            borderBottom: '1px solid black',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        CÓDIGO
                                    </StyledTableCell>
                                )}
                                {configs.showBarcodeOnNote && (
                                    <StyledTableCell
                                        sx={{
                                            borderBottom: '1px solid black',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        CÓDIGO BAR.
                                    </StyledTableCell>
                                )}
                                <StyledTableCell
                                    sx={{
                                        borderBottom: '1px solid black',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    CANT. / DESC.
                                </StyledTableCell>
                                <StyledTableCell
                                    sx={{
                                        borderBottom: '1px solid black',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    P. VENTA
                                </StyledTableCell>
                                <StyledTableCell
                                    sx={{
                                        borderBottom: '1px solid black',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    SUBTOTAL
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {budget.products.map((product) => (
                                <TableRow sx={{ height: '0' }}>
                                    {configs.showImageOnNote && (
                                        <StyledTableCell>
                                            <Box
                                                component={'img'}
                                                src={
                                                    product.product.image
                                                        ? getFileEndpoint(
                                                              product.product
                                                                  .image
                                                                  ?.content
                                                          )
                                                        : undefined
                                                }
                                                height={'50px'}
                                                padding={'3px'}
                                            />
                                        </StyledTableCell>
                                    )}
                                    {configs.showIdOnNote && (
                                        <StyledTableCell>
                                            {product.product.internalCodes[0]}
                                        </StyledTableCell>
                                    )}
                                    {configs.showBarcodeOnNote && (
                                        <StyledTableCell>
                                            {product.product.barcodes[0] ||
                                                '---'}
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>
                                        {product.qnt} /{' '}
                                        {product.product.parsedName}
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        {maskCurrency(
                                            product.notePrice,
                                            budget.coin
                                        )}
                                    </StyledTableCell>
                                    <StyledTableCell
                                        sx={{ borderRight: 'none' }}
                                    >
                                        {maskCurrency(
                                            product.subtotal,
                                            budget.coin
                                        )}
                                    </StyledTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Stack>
                <Stack
                    width={'100%'}
                    border={'1px solid black'}
                    borderTop={'0'}
                    borderRadius={'12px'}
                    pl={'10px'}
                    pb={'5px'}
                >
                    <Stack
                        direction={'row'}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                    >
                        <Stack>
                            <Typography fontSize={'12px'}>
                                Total a pagar:{' '}
                                <Box component={'span'} fontSize={'11px'}>
                                    (En letras)
                                </Box>{' '}
                                {numeroPorExtensoEspanhol(budget?.total, budget.coin)}
                            </Typography>
                            <Typography fontSize={'12px'}>
                                Nº de itens:{' '}
                                {budget.products.reduce(
                                    (total, current) => total + current.qnt,
                                    0
                                )}
                            </Typography>
                            {budget.annotation && (
                                <Typography fontSize={'12px'}>
                                    Nota: {budget.annotation}
                                </Typography>
                            )}
                        </Stack>
                        <Typography
                            fontSize={'12px'}
                            borderLeft={'1px solid black'}
                            borderBottom={'1px solid black'}
                            p={'5px'}
                        >
                            {maskCurrency(budget.total, budget.coin)}
                        </Typography>
                    </Stack>
                </Stack>
                {!!configs.observationBudget && (
                    <Stack
                        width={'100%'}
                        border={'1px solid black'}
                        borderTop={'0'}
                        borderRadius={'12px'}
                        pl={'10px'}
                        pb={'5px'}
                    >
                        <Typography fontSize={'12px'}>
                            {configs.observationBudget}
                        </Typography>
                    </Stack>
                )}
            </Stack>
        </Stack>
    )
}

interface Props {
    budgets: PreSaleInfo[]
    handleClose(): void
    dontPrint?: boolean
    isMatrix?: boolean
}

export function BudgetA4NoteDialog({
    handleClose,
    budgets,
    dontPrint,
    isMatrix,
}: Props) {
    const { configs } = useConfigs()
    const { accountInfo } = useAccount()
    const printRef = useRef<HTMLElement>()

    useEffect(() => {
        if (!isMatrix) {
            if (!printRef.current) return

            if (!dontPrint) {
                printRef.current!.style.visibility = 'hidden'
                printRef.current!.style.position = 'fixed'
            }

            quandoImagensCarregarem(printRef.current).then(() => {
                const twoPages = !configs.printHalfPage || dontPrint

                for (let child in printRef.current!.children) {
                    if (isNaN(Number(child))) continue
                    const element = printRef.current!.children[
                        child
                    ] as HTMLElement

                    const a4HeightPx = 1122
                    let heightInVh = (element.offsetHeight / a4HeightPx) * 100

                    if (heightInVh < 50 && !twoPages) {
                        heightInVh = 50
                    } else {
                        heightInVh =
                            100 * (Math.floor((heightInVh - 1) / 100) + 1)
                    }

                    element.style.height = `${heightInVh}vh`
                }

                if (!dontPrint) {
                    setTimeout(() => {
                        printRef.current!.style.position = 'absolute'
                        printRef.current!.className = isMatrix
                            ? 'printableMatrix'
                            : 'printable'
                        window.scroll(0, 0)
                        window.print()
                        handleClose()
                    }, 100)
                }
            })
        } else {
            let finalContent = ''

            for (const budget of budgets) {
                while (budget.products.length) {
                    const { content, productsUsed } = getBudgetMatrixPrintText(
                        { ...budget },
                        configs
                    )

                    budget.products.splice(0, productsUsed)

                    console.log(content)
                    console.log(
                        `Número de linhas: ${content.split('\n').length}`
                    )

                    finalContent += content
                }
            }

            const baseHost =
                accountInfo?.localPrinterHost ?? 'http://localhost:3500'

            axios
                .post(`${baseHost}/imprimir`, {
                    conteudo: finalContent,
                    impressora: 'ImpressoraMatricial',
                })
                .catch((err) => console.log(err))
                .finally(() => handleClose())
        }
    }, [])

    if (isMatrix) return <></>

    return (
        <Box id="note" ref={printRef}>
            {budgets.map((budget) => (
                <>
                    {Array.from({
                        length: !dontPrint ? configs.budgetNotesQnt : 1,
                    }).map(() => (
                        <BudgeA4tNote budget={budget} />
                    ))}
                </>
            ))}
        </Box>
    )
}
